<svg:rect class="today" [style.stroke-width]="'1px'" y="0" x="0" [attr.width]="cfg.toolsSize.width"
          [attr.height]="cfg.toolsSize.height">
</svg:rect>
<svg:svg class="action" [attr.x]="cfg.toolsSize.width - 2 * cfg.cellWidth" y="0" [attr.width]="cfg.cellWidth"
         [attr.height]="cfg.cellHeight" (click)="onReset()">
    <svg:circle r="10" cx="12" cy="12">
    </svg:circle>
    <svg viewBox="0 0 1000 1000" x="5" y="6">
            <path d="M490.667,64H133.077c-7.196,0-13.906,3.627-17.848,9.647L3.485,244.314c-4.647,7.098-4.647,16.274,0,23.372
            				l111.744,170.667c3.942,6.02,10.652,9.647,17.848,9.647h357.589c11.782,0,21.333-9.551,21.333-21.333V85.333
            				C512,73.551,502.449,64,490.667,64z M469.333,405.333H144.609L46.833,256l97.776-149.333h324.725V405.333z" />
            <path d="M198.246,356.418c8.331,8.331,21.839,8.331,30.17,0l70.248-70.248l70.248,70.248c8.331,8.331,21.839,8.331,30.17,0
            				s8.331-21.839,0-30.17L328.834,256l70.248-70.248c8.331-8.331,8.331-21.839,0-30.17s-21.839-8.331-30.17,0l-70.248,70.248
            				l-70.248-70.248c-8.331-8.331-21.839-8.331-30.17,0c-8.331,8.331-8.331,21.839,0,30.17L268.495,256l-70.248,70.248
            				C189.915,334.58,189.915,348.087,198.246,356.418z" />
    </svg>
</svg:svg>
<svg:svg class="action" [attr.x]="cfg.toolsSize.width - cfg.cellWidth" y="0"
         [attr.width]="cfg.cellWidth" [attr.height]="cfg.cellHeight" (click)="onSubmit()">
    <svg:circle r="10" cx="12" cy="12">
    </svg:circle>
    <svg viewBox="0 0 24 24" x="7" y="7">
        <path d="M7.197,16.963H7.195c-0.204,0-0.399-0.083-0.544-0.227l-6.039-6.082c-0.3-0.302-0.297-0.788,0.003-1.087
							C0.919,9.266,1.404,9.269,1.702,9.57l5.495,5.536L18.221,4.083c0.301-0.301,0.787-0.301,1.087,0c0.301,0.3,0.301,0.787,0,1.087
                            L7.741,16.738C7.596,16.882,7.401,16.963,7.197,16.963z" transform="scale(0.5)">
        </path>
    </svg>
</svg:svg>
